import React from 'react'
import Button, { ButtonProps } from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import JobFormFooter from 'components/JobFormFooter'
import { NursePaygradeStats } from 'types/interfaces'

interface PricingInfoButtonProps extends ButtonProps {
  paygradeStats?: NursePaygradeStats
}

export default function PricingInfoButton({ paygradeStats, ...buttonProps }: PricingInfoButtonProps) {
  const [open, setOpen] = React.useState(false)
  if (!paygradeStats) return null
  return (
    <>
      <Button variant="outlined" startIcon={<InfoOutlinedIcon />} onClick={() => setOpen(true)} {...buttonProps}>
        Pricing Info
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Pricing Info</DialogTitle>
        <DialogContent>
          <JobFormFooter paygradeStats={paygradeStats} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
